import register from '@kpsys/angularjs-register';
import ReportServerService from './report-server.service';
import ReportServerDataService from './report-server.data-service';
import reportServerRoutes from './report-server.routes';
import KpReportServerFolderComponent from './kp-report-server-folder/kp-report-server-folder.component';
import KpReportTemplateItemComponent from './kp-report-template-item/kp-report-template-item.component';

/**
 * @ngdoc module
 * @name reportServerDataService
 * @module use-cases.report-server
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing the report-server
 */
export default register('use-cases.report-server')
    .service(ReportServerService.serviceName, ReportServerService)
    .service(ReportServerDataService.serviceName, ReportServerDataService)
    .component(KpReportServerFolderComponent.componentName, KpReportServerFolderComponent)
    .component(KpReportTemplateItemComponent.componentName, KpReportTemplateItemComponent)
    .config(reportServerRoutes)
    .name();
